import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import CryptoJS from "crypto-js";
import qs from "qs";
import * as XLSX from "xlsx";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const API_BASE_URL = "https://api.drivergems.com";

function generateSignature(method, urlPath, timestamp) {
  const secretKey = "jnpkXDAM1GBvyDxYITtukz43zekx6UXgpipODwW9KY5";
  const message = `${method}${urlPath}${timestamp}`;
  return CryptoJS.HmacSHA256(message, secretKey).toString(CryptoJS.enc.Hex);
}

const formatDateTime = (dateString) => {
  if (!dateString || dateString === "N/A") return "N/A";
  const date = new Date(dateString);
  return date.toLocaleString("en-IN", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
    timeZone: "Asia/Kolkata"
  });
};

const RewardPointsBalanceTable = ({ searchQuery, fromDate, toDate, filter, onExportRef, onRefreshRef,selectedRoId,onExportpdfRef }) => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [sortStates, setSortStates] = useState({ total_reward_points: "asc" });

  
  const sortData = () => {
    const key = "total_reward_points";
    const direction = sortStates[key] === "asc" ? "desc" : "asc";

    const sorted = [...filteredData].sort((a, b) => {
      const valA = a[key] ?? 0;
      const valB = b[key] ?? 0;
      return direction === "asc" ? valA - valB : valB - valA;
    });

    setFilteredData(sorted);
    setSortStates((prev) => ({ ...prev, [key]: direction }));
  };

  const fetchRewardPoints = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) return;

      const method = "GET";
      const timestamp = Math.floor(Date.now() / 1000).toString();
      const apiUrl = "/v1/user/consumerrewardpoints";
      const signature = generateSignature(method, apiUrl, timestamp);
      const queryParams = qs.stringify({ start_date: fromDate, end_date: toDate ,ro_id:selectedRoId});

      const response = await axios.get(`${API_BASE_URL}${apiUrl}?${queryParams}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Signature": signature,
          "X-Timestamp": timestamp
        }
      });

      const users = response.data?.users || [];
      setData(users);
      setFilteredData(users);
    } catch (error) {
      console.error("Error fetching reward points:", error);
    }
  };

  useEffect(() => {
    if (filter === "Select...") {
      setData([]);
      setFilteredData([]);
      return;
    }
    fetchRewardPoints();
  }, [filter, fromDate, toDate,selectedRoId]);

  useEffect(() => {
    const search = (searchQuery || "").toLowerCase();
    setFilteredData(
      data.filter(u =>
        (`${u.firstname || ""} ${u.lastname || ""}`.toLowerCase().includes(search)) ||
        (u.phone || "").toLowerCase().includes(search)
      )
    );
  }, [searchQuery, data,selectedRoId]);
useEffect(() => {
    if (onRefreshRef) onRefreshRef.current = fetchRewardPoints;
  }, [filteredData,selectedRoId]);

    useEffect(() => {
    if (onExportRef) onExportRef.current = () => {
         const exportData = filteredData.map(u => ({
      Name: `${u.firstname || ""} ${u.lastname || ""}`,
      Phone: u.phone || "N/A",
      "Total Reward Points": u.total_reward_points || 0,
      "Last Transaction Date": formatDateTime(u.last_transaction_date)
    }));
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Reward Points Balance");
      XLSX.writeFile(workbook, "reward_points_balance.xlsx");
    };
  }, [filteredData,selectedRoId,onExportRef]);

   useEffect(() => { fetchRewardPoints(); }, [selectedRoId]);
  
useEffect(() => {
  if (onExportpdfRef) onExportpdfRef.current = () => {
    if (!filteredData || filteredData.length === 0) {
      alert("No data to export!");
      return;
    }

    const exportpdfData = filteredData.map(u => ({
      Name: `${u.firstname || ""} ${u.lastname || ""}`.trim(),
      Phone: u.phone || "N/A",
      "Total Reward Points": u.total_reward_points || 0,
      "Last Transaction Date": formatDateTime(u.last_transaction_date)
    }));

    // Headers and body for autoTable
    const headers = Object.keys(exportpdfData[0]);
    const body = exportpdfData.map(row => headers.map(h => row[h]));

    // Create PDF
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4"
    });

    // Title
    const title = "Reward Points Balance";
    const marginLeft = 40;
    doc.setFontSize(14);
    doc.text(title, marginLeft, 40);

    // Table
    autoTable(doc, {
      startY: 60,
      head: [headers],
      body: body,
      styles: { fontSize: 10, cellPadding: 6 },
      headStyles: { fillColor: [240, 240, 240], textColor: 20, fontStyle: "bold" },
      margin: { left: marginLeft, right: 40 },
      didDrawPage: (dataArg) => {
        // Footer with page number
        const pageSize = doc.internal.pageSize;
        const pageHeight = pageSize.height || pageSize.getHeight();
        doc.setFontSize(9);
        doc.text(`Page ${dataArg.pageNumber}`, pageSize.width - 60, pageHeight - 10);
      }
    });

    // Save file
    doc.save("reward_points_balance.pdf");
  };
}, [filteredData, onExportpdfRef,selectedRoId]);

  // ✅ Export always uses latest filteredData from ref
 


  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow style={{background:"lightgrey"}}>
            <TableCell style={{border:"2px solid #a7a4a4"}}><strong>Name</strong></TableCell>
            <TableCell style={{border:"2px solid #a7a4a4"}}><strong>Phone</strong></TableCell>
            <TableCell onClick={sortData} style={{ cursor: "pointer",border:"2px solid #a7a4a4" }}>
              <strong>Total Reward Points {sortStates.total_reward_points === "asc" ? "🔼" : "🔽"}</strong>
            </TableCell>
            <TableCell style={{border:"2px solid #a7a4a4"}}><strong>Last Transaction Date</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredData.length > 0 ? (
            filteredData.map((u, i) => (
              <TableRow key={i}>
                <TableCell>{`${u.firstname || ""} ${u.lastname || ""}`}</TableCell>
                <TableCell>{u.phone || "N/A"}</TableCell>
                <TableCell>{u.total_reward_points || 0}</TableCell>
                <TableCell>{formatDateTime(u.last_transaction_date)}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={4} align="center">No data found</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RewardPointsBalanceTable;
